import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useBulkCreateLeagueMatches } from "../api/SeasonApiProvider";
import { LeagueSeasonGuardFallback, useLeagueSeasonGuard, } from "../seasons/useLeagueSeasonGuard";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { GameweekFixturesForm } from "./GameweekFixturesForm";
export const CreateGameweekFixtures = () => {
    const { leagueId, seasonId } = useNumericParams();
    const navigate = useNavigate();
    const guard = useLeagueSeasonGuard({ leagueId, seasonId });
    const mutation = useBulkCreateLeagueMatches({
        onSuccess: () => {
            navigate(`/leagues/${leagueId}/seasons/${seasonId}?tab=fixtures`);
        },
    });
    const onSubmit = (fixtures) => {
        mutation.mutate(fixtures);
    };
    if (guard.status !== "ready") {
        return _jsx(LeagueSeasonGuardFallback, { guard: guard });
    }
    const divisions = guard.season.divisions ?? [];
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create fixtures. Please check each row and try again." }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: _jsx("strong", { children: "Add Gameweek" }) }), _jsx(GameweekFixturesForm, { divisions: divisions, onSubmit: onSubmit, isSubmitting: mutation.isLoading, onCancel: () => navigate(`/leagues/${leagueId}/seasons/${seasonId}?tab=fixtures`) })] }));
};
